import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesQualification = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageQualificationsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesQualification}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageQualificationsInitializer.displayName = 'Page qualifications initializer component';

export default PageQualificationsInitializer;
